<template>
  <div class="side right-panel">
    <!-- <div class="panel-title">实时告警推送</div> -->
    <div style="height: 14vh">
      <div class="table-header">快捷入口</div>
      <div
        style="
          display: flex;
          justify-content: space-around;
          width: 100%;
          font-size: 14px;
          color: #005eb8;
          flex-wrap: wrap;
        "
      >
        <div
          style="
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            padding: 4px 0;

            margin-bottom: 6px 0;
          "
          v-for="(item, index) in quickMenus"
          :key="index"
          @click="entryClick(item.link)"
        >
          {{ item.title }}
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div style="height: 38h">
      <!-- 表头 -->
      <div class="table-header">
        <!-- <div class="col">驾驶员</div>
        <div class="col">行为</div>
        <div class="col">时间</div>
        <div class="col">照片</div> -->
        <div>异常行为统计</div>
      </div>

      <div class="table-list">
        <!-- 表头 -->

        <div class="table-title">
          <div class="col" style="width: 25%">驾驶员</div>
          <!-- <div class="col">行为</div> -->
          <div class="col" style="width: 25%">行为</div>
          <div class="col" style="width: 25%">时间</div>
          <div class="col" style="width: 25%">照片</div>
          <!-- <div class="col">照片</div> -->
        </div>

        <!-- 滚动列表区域 -->
        <div
          class="table-body"
          @mouseenter="paused = true"
          @mouseleave="paused = false"
        >
          <div class="scroll-wrapper" :class="{ paused }">
            <!-- 原始数据 -->
            <div
              class="table-row"
              v-for="(item, index) in behaviorList"
              :key="'a' + index"
            >
              <!-- <div class="col driverName" style="width: 45%">
                  {{ item.driverName }}
                </div>
                <div class="col" style="width: 45%">
                  {{ item.workTime }}
                </div> -->
              <div class="col">{{ item.driverName }}</div>
              <div class="col">
                <dict-tag
                  :options="dict.type.abnormal_type"
                  :value="item.actionType"
                />
              </div>
              <div class="col">{{ getDateTime(item.startTime) }}</div>

              <div class="col">
                <img
                  v-if="isFullscreen"
                  :src="fileShowUrl + item.photo"
                  class="photo-img"
                />
                <image-preview
                  v-else
                  :src="fileShowUrl + item.photo"
                  :allSrcList="
                    behaviorList.map((item) => fileShowUrl + item.photo)
                  "
                  :width="40"
                  :height="40"
                />
              </div>
              <!-- <div class="col"></div> -->
            </div>
            <div
              class="table-row"
              v-for="(item, index) in behaviorList"
              :key="'b' + index"
            >
              <!-- <div class="col driverName" style="width: 45%">
                  {{ item.driverName }}
                </div>
                <div class="col" style="width: 45%">
                  {{ item.workTime }}
                </div> -->
              <div class="col">{{ item.driverName }}</div>
              <div class="col">
                <dict-tag
                  :options="dict.type.abnormal_type"
                  :value="item.actionType"
                />
              </div>
              <div class="col">{{ getDateTime(item.startTime) }}</div>

              <div class="col">
                <img
                  v-if="isFullscreen"
                  :src="fileShowUrl + item.photo"
                  class="photo-img"
                />
                <image-preview
                  v-else
                  :src="fileShowUrl + item.photo"
                  :allSrcList="
                    behaviorList.map((item) => fileShowUrl + item.photo)
                  "
                  :width="40"
                  :height="40"
                />
              </div>
              <!-- <div class="col"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中部内容块 -->
    <div class="middle-section" style="height: 38vh">
      <div class="table-header">
        <div>所有项目关键数据月度走势图</div>
        <!-- <div class="toInfo" @click="toInfo('projectRating')">详情</div> -->
      </div>

      <div class="chart_part">
        <!-- <div class="flex" style="margin-bottom: 1vh"> -->
        <div class="chart">
          <MultiLineChart :xAxisLabels="timeLabels" :seriesData="chartSeries" />
        </div>
        <!-- </div> -->
      </div>

      <!-- <div>
        <div class="table-header">
          <div>近30天劳务队评分</div>
          <div class="toInfo" @click="toInfo('workerRating')">详情</div>
        </div>

        <div class="chart_part">
          <div class="flex" style="margin-bottom: 3vh">
            <div class="chart">
              <ChartsColumn :ytitle="'分'" :data="workerRatingData" />
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import { listBehavior } from '@/api/iemanage/behavior'
// import { queryIeDeviceCount } from '@/api/iemanage/drivers_screen'

export default {
  name: 'RightAlertPanel',
  dicts: ['abnormal_type'],
  components: {
    MultiLineChart: () => import('../charts_drivers/MultiLineChart.vue')
  },
  props: {
    // 是否全屏
    isFullscreen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      fileShowUrl: process.env.VUE_APP_BASE_API + '/file', // 文件回显的服务器地址
      timeLabels: [],
      quickMenus: [
        {
          title: '智能终端',
          link: '/manage/iemanage/smart-device',
          icon: 'el-icon-set-up'
        },
        {
          title: '塔司管理',
          link: '/manage/iemanage/drivers-page',
          icon: 'el-icon-user'
        },
        {
          title: '汇总报表',
          link: '/manage/iemanage/score-statistics',
          icon: 'el-icon-document'
        },
        // {
        //   title: '得分统计',
        //   link: '/manage/iemanage/score-statistics',
        //   icon: 'el-icon-document'
        // },
        {
          title: '岗前播报',
          link: '/manage/iemanage/broadcast',
          icon: 'el-icon-tickets'
        }
      ],
      chartSeries: [
        // { name: '异常数', data: [5, 12, 9, 14, 10] },
        // { name: '设备离线', data: [2, 5, 3, 4, 6] },
        // { name: '安全违规', data: [1, 3, 2, 5, 4] }
      ],
      dataInterval: null,
      paused: false,
      alerts: [],
      behaviorList: [],
      queryParams: {
        pageSize: 20,
        pageNum: 1,
        params: {}
      }
    }
  },
  async mounted() {
    // await this.defaultTime()
    // // 轮询
    // this.getBehaviorList()
    // // 初始化加载一次
    // this.dataInterval = setInterval(() => {
    //   this.getBehaviorList()
    // }, 5 * 60 * 1000)
    // this.queryIeDeviceCountFn()
  },
  beforeDestroy() {
    // clearInterval(this.dataInterval)
  },
  methods: {
    // 默认时间
    defaultTime() {
      // 默认当前日期之前7天
      let sdate = new Date()
      let interval = -7 //间隔天数
      let caret = '-' //日期分隔符
      let strYear = sdate.getFullYear()
      let strDay = sdate.getDate()
      let strMonth = sdate.getMonth() + 1
      let patt1 = /^\d{4}-([0-1]?[0-9])-([0-3]?[0-9])$/ //判断输入的日期是否符合格式正则表达式
      if (!(sdate && typeof sdate == 'string' && patt1.test(sdate))) {
        sdate = new Date() //不满足日期的则使用当前年月日
      }
      interval = isNaN(parseInt(interval)) ? 0 : parseInt(interval) //若没有输入间隔，则使用当前日
      caret = caret && typeof caret == 'string' ? caret : ''
      let gdate = new Date(sdate).getTime() //获取指定年月日
      gdate = gdate + 1000 * 60 * 60 * 24 * interval //加减相差毫秒数
      let speDate = new Date(gdate) //获取指定好毫秒数时间
      let preYear = speDate.getFullYear()
      let preMonth = speDate.getMonth() + 1
      let preDay = speDate.getDate()
      preMonth = preMonth < 10 ? '0' + preMonth : preMonth
      strMonth = strMonth < 10 ? '0' + strMonth : strMonth
      preDay = preDay < 10 ? '0' + preDay : preDay
      strDay = strDay < 10 ? '0' + strDay : strDay
      let preDate = preYear + caret + preMonth + caret + preDay
      let endDate = strYear + '-' + strMonth + '-' + strDay
      this.queryParams.params.beginTime = preDate
      this.queryParams.params.endTime = endDate
    },
    // /** 查询驾驶异常行为统计列表 */
    // getBehaviorList() {
    //   listBehavior(this.queryParams).then((response) => {
    //     let behaviorList = response.data
    //     this.behaviorList = behaviorList
    //     // this.total = response.total
    //     // this.loading = false
    //   })
    // },
    // 点击卡片快捷入口
    entryClick(link) {
      this.$router.push(link)
    },
    // queryIeDeviceCountFn() {
    //   let that = this

    //   queryIeDeviceCount({}).then((response) => {
    //     if (response.data && response.data.length > 0) {
    //       let arr = response.data
    //       that.timeLabels = arr.map((item) => {
    //         const time = item.createTime.split(' ')[0] || '' // 取空格后面的时分秒部分
    //         return time
    //       })

    //       let chartSeries = [
    //         {
    //           name: '打卡率',
    //           type: 'line',
    //           data: arr.map((item) =>
    //             parseFloat(item.clockRate.replace('%', ''))
    //           )
    //         },
    //         {
    //           name: '在线率',
    //           type: 'line',
    //           data: arr.map((item) =>
    //             parseFloat(item.onlineRate.replace('%', ''))
    //           )
    //         },
    //         {
    //           name: '平均得分',
    //           type: 'line',
    //           data: arr.map((item) => Number(item.score))
    //         }
    //       ]
    //       that.chartSeries = chartSeries
    //     }
    //   })
    // },
    getDateTime(time) {
      if (time) {
        let newTime = time.split(' ')
        return newTime[1]
      }
    },
    /** 图表去详情 */
    toInfo(el) {
      if (el == 'projectRating') {
        // 项目评分
        // this.$router.push(`/manage/iemanage/acount-project`)
        this.$router.push({
          path: '/manage/iemanage/score-statistics?type=1'
        })
      }
    }
  },
  resize() {}
}
</script>

<style lang="scss" scoped>
/* ✅ 整体右侧面板背景 */
// .top-section {
//   margin-top: 1vh;
// }

/* ✅ 标题蓝色主色 */
.panel-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #005eb8;
}

/* ✅ 表头样式 */
.table-header {
  display: flex;
  // background: #e6f0fa; /* 浅蓝灰背景 */
  margin: 10px 0;
  padding: 0 20px;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  // color: #000;
  font-weight: bold;
  // border: 2px solid;
  background: linear-gradient(
    to right,
    rgba(85, 144, 217, 0.4),
    rgba(85, 144, 217, 0.05)
  );
  position: relative;
  // border-image-slice: 1;
  // transition: all 0.4s ease;
  // background: #005eb8;

  border-radius: 16px 16px 0 0;
  height: 32px;
}
.border-technique {
  background: rgb(180, 195, 229);
  clip-path: polygon(30% 0, 100% 0, 70% 100%, 0 100%);
}
.table-list {
  display: flex;
  border-radius: 10px;

  flex-direction: column;
  border: 1px solid #ccc;
}
.table-title {
  display: flex;
  background: rgba(85, 144, 217, 0.1); /* 浅蓝灰背景 */
  padding: 0 20px;
  font-size: 16px;
  align-items: center;
  justify-content: space-around;

  height: 32px;
}
/* ✅ 表格行 */
.table-row {
  display: flex;
  justify-content: space-around;
  padding: 4px 0;
  border-bottom: 1px solid #d0dce7;
}

/* ✅ 通用列样式 */
.col {
  // padding: 0 8px;
  overflow: hidden;
  display: flex;
  width: 25%;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-overflow: ellipsis;
}

/* ✅ 驾驶员列 */
.driver {
  width: 80px;
  /* color: #007bff; */
  white-space: nowrap;
}

/* ✅ 异常行为列换行 */
.message {
  flex: 1;
  /* color: #005eb8; */
  word-wrap: break-word;
  word-break: break-word;
  text-align: left;
  white-space: normal;
}

/* ✅ 照片列 */
.photo {
  width: 80px;
  flex-shrink: 0;
}

/* ✅ 图片样式 */
.photo-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
}

/* ✅ 滚动区域样式 */
.table-body {
  height: 26vh;
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: transparent;
}

/* ✅ 滚动动画 */
.scroll-wrapper {
  display: inline-block;
  width: 100%;

  animation: scroll-up 80s linear infinite;
}
.scroll-wrapper.paused {
  animation-play-state: paused;
}
@keyframes scroll-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
/* 中部内容 */
.middle-section {
  flex: 1;
  // padding: 10px 0;
  // margin: 1vh 0;
  /* background: #ffffff; */
  /* border: 1px solid #b4cce5; */
  /* border-radius: 8px; */
  /* box-shadow: 0 4px 12px rgba(0, 94, 184, 0.1); */
  overflow: hidden;
}
.panel-box {
  display: flex;
  justify-content: space-between;
}
.panel-title {
  font-size: 14px;
  font-weight: bold;
  color: #005eb8;
  margin-bottom: 10px;
}
.toInfo {
  // color: #409eff;
  color: #999;
  font-size: 12px;
  float: right;
}
.toInfo:hover {
  cursor: pointer;
}
.chart_part {
  margin-top: 1vh;
  margin-bottom: 1vh;

  .chart {
    // border: #e6e8ec 1px solid;
    // box-sizing: border-box;
    width: 100%;
    height: 30vh;
    background-color: transparent;
    // border-radius: 10px;
    // padding: 0 10px;
    // margin-right: 1%;
  }
}
.container {
  width: 100%;
  // max-width: 1200px;
  // text-align: center;
  display: flex;
  flex-direction: column;
}

.status-cards {
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 25px;
}

.card {
  // background: rgba(255, 255, 255, 0.95);
  // border-radius: 16px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 10px;
  // width: 300px;
  transition: all 0.3s ease;
  // backdrop-filter: blur(10px);
  // border: 1px solid rgba(255, 255, 255, 0.2);
}

.card:hover {
  transform: translateY(-5px);
  // box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.status-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.online {
  background: linear-gradient(135deg, #00b09b, #96c93d);
  box-shadow: 0 0 10px rgba(0, 176, 155, 0.5);
}

.offline {
  background: linear-gradient(135deg, #8e0e00, #1f1c18);
}

.warning {
  background: linear-gradient(135deg, #ff8c00, #ffcc00);
}
.totalcount {
  background: linear-gradient(135deg, #3498db, #2980b9);
}
.status-title {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.server-count {
  cursor: pointer;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
}
.server-count:hover {
  color: #005eb8;
}
.server-label {
  color: #7f8c8d;
  font-size: 1rem;
  margin-bottom: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
}

.btn-secondary {
  background: #ecf0f1;
  color: #7f8c8d;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.chart-container {
  height: 100px;
  margin: 20px 0;
}
</style>
